var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"APP"}},[(_vm.$route.name == 'main')?_c('banner'):_vm._e(),_c('gnb-area'),_c('router-view'),_c('footer-area'),_c('vue-confirm-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }